import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../Provider/Alert/AlertContext";
import { getData } from "../../Services/apiService";

export function useAccountReceivable({ idClient }) {
    const [accountReceivable, setAccountReceivable] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState({}); // Search hook
    const { t } = useTranslation(); // Translation hook
    const { addAlert } = useAlert(); // Alert hook
    const [reloadFlag, setReloadFlag] = useState(0); // State to trigger reloads

    const getListAccountReceivable = async () => {
        // Get the query string from the local storage
        let queryString = JSON.parse(
            localStorage.getItem("clients_account_receivable")
        );

        if (!queryString) {
            queryString = {
                page: 1,
                limit: 10,
                totalItems: 0,
                order: [{ field: "id", direction: "asc" }],
            };
            localStorage.setItem(
                "clients_account_receivable",
                JSON.stringify(queryString)
            );
        }

        console.log("Account Receivable Response: (querystring)", queryString);

        // Get the licenses for the client
        let uri = `/client/${idClient}/account_receivable?page=${queryString.page}&limit=${queryString.limit}`;

        // Adicionar ordenações à URI
        const orderString = encodeURIComponent(
            JSON.stringify(queryString.order)
        );
        uri += `&order=${orderString}`;

        // Add search parameters to the URI
        const whereClasules = getWhereClasules();
        if (whereClasules.length > 0) {
            // Add AND operator if there are existing clauses
            const whereString = encodeURIComponent(
                JSON.stringify(whereClasules)
            );
            uri += `&where=${whereString}`;
        }

        setLoading(true);

        // Await the response
        const getLicenses = getData(uri);
        calculateTotal(uri);

        getLicenses.then((response) => {
            if (response.status === 200) {
                setAccountReceivable(response.body.data);
                queryString.lastPage = response.body.total_pages || 1;
                queryString.totalItems = response.body.total_items || 0;
                localStorage.setItem(
                    "clients_account_receivable",
                    JSON.stringify(queryString)
                );
                setLoading(false);
                return;
            }
            addAlert("danger", t("license.alert.error"), response.body);
        });
    };

    const getWhereClasules = () => {
        let whereClause = [];

        // Build creation date range clauses
        let rangeCreateAt = [];
        if (search.create_at_init) {
            // Start date for creation date range
            rangeCreateAt.push({
                field: "create_at",
                operator: ">=",
                value: search.create_at_init,
            });
        }
        if (search.create_at_end) {
            // End date for creation date range
            rangeCreateAt.push({
                field: "create_at",
                operator: "<=",
                value: search.create_at_end,
            });

            // If both start and end dates are provided, add logical operators
            if (search.create_at_init) {
                rangeCreateAt[0].logic_operator = "AND";
                rangeCreateAt[0].group_start = true;
                rangeCreateAt[1].group_end = true;
            }
        }

        // Add creation date range to where clause
        whereClause = whereClause.concat(rangeCreateAt);

        // Build payment date range clauses
        let rangePaymentDate = [];
        if (search.payment_date_init) {
            rangePaymentDate.push({
                field: "payment_date",
                operator: ">=",
                value: search.payment_date_init,
            });
        }
        // Add end date for payment date range
        if (search.payment_date_end) {
            rangePaymentDate.push({
                field: "payment_date",
                operator: "<=",
                value: search.payment_date_end,
            });

            // If both start and end dates are provided, add logical operators
            if (search.payment_date_init) {
                rangePaymentDate[0].logic_operator = "AND";
                rangePaymentDate[0].group_start = true;
                rangePaymentDate[1].group_end = true;
            }

            // Add payment date range to where clause
            whereClause = whereClause.concat(rangePaymentDate);
        }

        // Add payment date range to where clause
        if (search.id_game) {
            whereClause.push({
                field: "id_game",
                operator: "=",
                value: parseInt(search.id_game, 10),
            });

            // Add AND operator if there are existing clauses
            if (whereClause.length > 1) {
                whereClause[whereClause.length - 2].logic_operator = "AND";
            }
        }
        return whereClause;
    };

    useEffect(() => {
        if (idClient) {
            localStorage.setItem(
                "clients_account_receivable_search",
                JSON.stringify({
                    search,
                })
            );
            getListAccountReceivable();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idClient, reloadFlag]);

    useEffect(() => {
        const storedSearch = localStorage.getItem(
            "clients_account_receivable_search"
        );

        console.log("Stored Search:", storedSearch);

        // If there is a stored search, use it to set the search state
        if (storedSearch) {
            setSearch(JSON.parse(storedSearch).search);
        } else {
            const now = new Date();
            setSearch({
                ...search,
                create_at_init: new Date(
                    now.getFullYear(),
                    now.getMonth(),
                    1,
                    0,
                    0,
                    0,
                    0
                ),
                create_at_end: new Date(
                    now.getFullYear(),
                    now.getMonth() + 1,
                    0,
                    23,
                    59,
                    59,
                    999
                ),
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [totalsValue, setTotalsValue] = useState({});
    const calculateTotal = async (account_receivable_uri) => {
        let uri = account_receivable_uri.replace(
            "/account_receivable?",
            "/account_receivable/totals?"
        );

        const getTotals = await getData(uri);

        console.log("Totals Response:", getTotals);

        if (getTotals.status === 200) {
            setTotalsValue(getTotals.body.data);
        }
    };

    return {
        accountReceivable,
        setAccountReceivable,
        loading,
        search,
        setSearch,
        totalsValue,
        reload: () => setReloadFlag(reloadFlag + 1),
    };
}
